<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <div id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考試資訊確認</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次代碼</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>考試方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="examMethodList" item-text="title" item-value="valuev" v-model="datasets.exportStatus">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="companyInfo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="examDate"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="payGroup"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class1"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class2"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class3"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證費用</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examFee"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
              <!-- <v-col cols="2" class="py-0 pl-0"> -->
                <div class="text-right pt-1 ml-0 pt14" style="line-height:1.2"><span class="start">*</span>報名繳費截止日期</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div id="box" class="pa-5 mt-3">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考試資訊確認</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense background-color="#F4F8F9" readonly outlined placeholder="請輸入" v-model="memberInfo.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>羅馬拼音</div>
              </v-col>
              <v-col class="col-7 col-md-6">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請務必填寫正確護照姓名，若需修正需付費申請" v-model="memberInfo.englishName"
                @keyup="memberInfo.englishName = memberInfo.englishName.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.englishName = $Global.toCDB(memberInfo.englishName)"></v-text-field>
              </v-col>
              <v-col class="col-3 col-md-2 pa-0 pt-2 ml-n2">
                <a href="https://www.boca.gov.tw/sp-natr-singleform-1.html" target="_blank" class="pt14">同護照</a>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>身分證字號(ID)</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>出生年月日</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.birthday"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>性別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.gender">
                  <v-row>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">女</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">男</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不提供</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => memberInfo.email = val' :domains='mailCandidateList'>
                  <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" v-model='memberInfo.email'
                  @keyup="[$refs.EmailAutoComplete.check($event), memberInfo.email= memberInfo.email.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.email = $Global.toCDB(memberInfo.email)]" />
                </email-auto-complete>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="memberInfo.collegeCategory"></v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-autocomplete v-if="memberInfo.collegeCategory!='4'" class="text_field autocomplete" placeholder="請選擇學校名稱"
                :items="schoolList" item-text="name" item-value="name" v-model="memberInfo.company"></v-autocomplete>
                <v-text-field v-if="memberInfo.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入單位名稱" v-model="memberInfo.company"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入系所/部門" v-model="memberInfo.department"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">聯絡電話</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" v-model="memberInfo.tel"
                @keyup="memberInfo.tel = memberInfo.tel.replace(/[\u4e00-\u9fa5]/ig,'') && memberInfo.tel.toUpperCase(), memberInfo.tel = $Global.toCDB(memberInfo.tel)"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" v-model="memberInfo.ctel"
                @keyup="[memberInfo.ctel= memberInfo.ctel.replace(/\D/g,'')]" :maxlength="10"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>郵遞區號</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="自動顯示" v-model="memberInfo.zipCode"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-row class="px-3" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
                  <v-select class="text_field mr-2" dense background-color="white" outlined style="width:48%" placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" v-model="memberInfo.country"></v-select>
                  <v-select class="text_field" dense background-color="white" outlined style="width:48%" placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" v-model="memberInfo.area"></v-select>
                </v-row>
                <v-row class="px-3">
                  <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入詳細地址" v-model="memberInfo.address"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>企業徵才用</div>
              </v-col>
              <v-col class="col-10 col-md-8 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.recruitmentAgree">
                  <v-row class="mr-0 pa-0">
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">同意</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不同意</span>
                      </template>
                    </v-radio>
                    <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                      <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                    </div>
                    <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:96px">
                      <h4 class="px-2 pt-3" style="font-size:12pt">※ 已同意將個資提供中華企業資源規劃學會使用</h4>
                      <h4 class="px-2 pb-3" style="font-size:12pt">我願意被企業徵才查詢</h4>
                    </div>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>報考身份別</div>
              </v-col>
              <v-col class="col-10 col-md-8 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense v-model="examMemberType">
                  <v-row>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">一般</span>
                      </template>
                    </v-radio>
                    <!-- <v-radio v-if="memberInfo.memberType=='erpTeacher' && memberInfo.memberStatus=='0'" class="pr-2" value="3" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">老師</span>
                      </template>
                    </v-radio> -->
                    <v-radio class="pr-2" value="4" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">身心障礙</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="5" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">低收入戶</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="6" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">其他</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>收據抬頭</div>
              </v-col>
              <v-col class="col-10 col-sm-6 col-md-5">
                <v-text-field class="text_field" dense outlined placeholder="請輸入收據抬頭" v-model="receiptTitle"
                :readonly="(sameName==true)" :background-color="(sameName == true)?'#F4F8F9':'#FFF'">
                </v-text-field>
              </v-col>
              <v-col class="col-8 col-sm-4 col-md-3 pt-1">
                <v-checkbox class="ma-0 pa-0" v-model="sameName">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">與中文姓名同</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col class="px-0 col-2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
          </v-col>
          <v-col v-if="memberType!='erpTeacher'" class="col-10 py-0 pt-2 pl-5">
            <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.jobtitle">
              <v-row>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">高中生(含五專)</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="2" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">大學生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="3" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">碩士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="4" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">博士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="5" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">教師</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="6" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">社會人士</span>
                  </template>
                </v-radio>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col v-if="memberType=='erpTeacher'" class="col-10 col-md-4 py-0">
            <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入詳細地址" v-model="memberInfo.jobtitle"></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" @click="checkInformation()">
        <span style="color:#FFFFFF">送出報名資料</span>
      </v-btn>
      <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
      <SubmitRegistration ref="SubmitRegistration" :onSave="newDataset"/>
    </div>
  </div>
</template>

<script>
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import SubmitRegistration from '@/dialogs/SubmitRegistration'
export default {
  name: 'Registration',
  components: {EmailAutoComplete, ShowMsg, Loading, SubmitRegistration},
  mounted(){
    this.datasets = JSON.parse(this.$Global.decrypt(this.$route.query.data))
    if(this.datasets.exportStatus =='4'){
      this.companyInfo = this.datasets.company
    }else{
      this.companyInfo = this.datasets.company + '-' + this.datasets.examClassroom
    }
    this.payGroup = (this.datasets.payGroup=='1') ? '團體繳費': (this.datasets.payGroup=='2') ? '個人繳費': ''
    this.examDate = this.datasets.examDate + ' ' + this.datasets.examTime
    this.deadline = this.datasets.deadlineDate + ' ' + this.datasets.deadlineTime
    this.memberType = (sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? 'erpMember' : 'erpTeacher'
    this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res })
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res })
    this.$Global.getCountryList().then(res=>{ this.countryList = res })
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getClassItemClass3List(this.datasets.class1, this.datasets.class2).then(res=>{ this.classItemClass3List = res })
    this.getMemberInfo()
    setTimeout(() => { this.initDone = true; }, 1000); //delay 1s
  },
  data:() => ({
    datasets: [],
    memberInfo: {},
    viewStyle:{},
    mouseInfor:0,
    memberType:'',
    initDone: false,
    isLoading: false,
    
    mailCandidateList: [],
    collegeCategoryList: [],
    examMethodList: [],
    schoolList: [],
    countryList: [],
    areaList: [],
    frontendAreaList: [],
    classItemClass3List: [],
    feeTypeList: [],
    companyInfo:'', //合併company + examClassroom
    payGroup:'', //轉換
    examDate:'', //合併examDate + examTime
    deadline:'', //合併deadlineDate + deadlineTime

    receiptTitle:'',
    examination:'',
    examMemberType:'',
    // feeType:'',
    havePay:'',
    sameName:false,
    requiredField:['name','englishName','idCard','birthday','gender','email','collegeCategory','company','department','ctel','address','recruitmentAgree','jobtitle'],
    requiredFieldOther:['zipCode','country','area'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "memberInfo.collegeCategory":function(){
      this.$Global.getSchoolList(this.memberInfo.collegeCategory, true).then(res=>{ this.schoolList = res })
    },
    "memberInfo.country":function(){
      if(this.initDone){
        this.memberInfo.zipCode = ''
      }
      this.$Global.getAreaListByCountryList(this.memberInfo.country).then(res=>{ this.areaList = res })
    },
    "memberInfo.area":function(){
      this.memberInfo.zipCode = this.$Global.getZipCode(this.areaList, this.memberInfo.area, this.memberInfo.zipCode)
    },
    "sameName":function(){
      if(this.sameName == true){
        this.receiptTitle = this.memberInfo.name
      }
    },
    "examMemberType":function(){
      // 以報考身份別改變認證費用
      if(this.examMemberType === '1'){
        this.havePay = this.datasets.examFee
      } else {
        this.havePay = this.$Global.getHavePay(this.classItemClass3List,this.datasets.class3,this.examMemberType)
      }
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    getMemberInfo(){
      var self = this
      var request = {
        method: 'GET',
        url: ((sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? '/erpMember/' : '/erpTeacher/') + sessionStorage.getItem('cerpsMemberId'),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.memberInfo = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Rgn-7956')
      })
    },
    checkInformation(){
      if(!this.$Global.checkForm(this.memberInfo,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.memberInfo.citizenShip=='1' || !this.memberInfo.citizenShip){
        if(!this.$Global.checkForm(this.memberInfo,this.requiredFieldOther)){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      if(!this.examMemberType || !this.receiptTitle){
        this.$refs.ShowMsg.open(1)
        return
      }
      this.$refs.SubmitRegistration.open()
    },
    newDataset() {
      this.isLoading = true
      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,this.memberInfo)
      allData = this.$Global.jsonConcat(allData,{'examCompany':this.datasets.company})
      allData = this.$Global.jsonConcat(allData,{'receiptTitle':this.receiptTitle})
      allData = this.$Global.jsonConcat(allData,{'sameName':this.sameName})
      allData = this.$Global.jsonConcat(allData,{'examMemberType':this.examMemberType})
      // allData = this.$Global.jsonConcat(allData,{'feeType':this.feeType})
      allData = this.$Global.jsonConcat(allData,{'havePay':this.havePay})
      allData = this.$Global.jsonConcat(allData,{'realPay':this.havePay})
      allData = this.$Global.jsonConcat(allData,{'createId':sessionStorage.getItem('cerpsMemberIdCard')})
      var self = this
      var request = {
        method: 'POST',
        url: '/erpExamReg',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.isLoading = false
        self.$refs.ShowMsg.open(0,'專案認證報名成功','若為個人繳費，請點選左列報名資訊查詢>前往繳費，進行繳款 ! 考前三天將發送通知簡訊，請您留意考試相關訊息 !',true,true)
      }).catch(()=>{
        self.isLoading = false
        self.$refs.ShowMsg.open(0,'系統錯誤','報名失敗，請聯繫系統管理人員，編號為Rgn-7957')
      })
    },
    onShowMsg(){
      this.redirectPath('/registerInformationList')
      this.$root.$emit('menuName', '使用者專區');
      this.$root.$emit('subMenuName', '報名資訊查詢')
    },
  }
}
</script>